import React, {useEffect} from 'react'
import AppLayout from '../components/layout'
import AppRouter from '../routes/appRouter'
import {ConfigProvider} from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import enUS from 'antd/es/locale/en_US'
import moment from 'moment'
import 'moment/locale/zh-cn'
import {useTranslation} from 'react-i18next'
import leftBar from '../assets/images/leftBar.png'

const storage = window.localStorage

const App = () => {
  const {i18n} = useTranslation()

  useEffect(() => {
    const themeStyle = JSON.parse(storage.getItem('themeStyle')) || {}
    const root = document.documentElement
    root.style.setProperty('--menu-background-color', themeStyle?.menuBackgroundColor || '#073a78')
    root.style.setProperty('--menu-background-image', `url(${themeStyle?.menuBackgroundImage || leftBar})`)
    root.style.setProperty('--primary-color', themeStyle?.primaryColor || '#073a78')
    root.style.setProperty('--primary-hover-color', themeStyle?.primaryHoverColor || '#1d59b3')
    root.style.setProperty('--danger-color', themeStyle?.dangerColor || '#e10031')
    root.style.setProperty('--danger-hover-color', themeStyle?.dangerHoverColor || '#f3476c')
    root.style.setProperty('--button-border-radius', themeStyle?.buttonBorderRadius || '42px')
    root.style.setProperty('--menu-item-background-color', themeStyle?.menuItemBackgroundColor || '#01244f')
    root.style.setProperty('--table-th-height', themeStyle?.tableThHeight || '50px')
    root.style.setProperty('--table-tr-height', themeStyle?.tableTrHeight || '30px')
    root.style.setProperty('--table-tr-line-height', themeStyle?.tableTrLineHeight || '20px')
    root.style.setProperty('--table-tr-border', themeStyle?.tableTrBorder || '0')
    root.style.setProperty('--form-item-label-height', themeStyle?.formItemLabelHeight || '20px')
    root.style.setProperty('--table-td-padding', themeStyle?.tableTdPadding || '10px 20px')
    root.style.setProperty('--table-even-row-bg', themeStyle?.tableEvenRowBg || 'rgb(247, 250, 252)')
    root.style.setProperty('--table-row-hover-bg', themeStyle?.tableRowHoverBg || '#dde7f7')
    root.style.setProperty('--table-odd-row-bg', themeStyle?.tableOddRowBg || '#ffffff')
  }, [])

  moment.locale(i18n.language === 'zh_CN' ? 'zh-cn' : 'en')

  return (
    <ConfigProvider locale={i18n.language === 'zh_CN' ? zhCN : enUS}>
      <AppLayout>
        <AppRouter/>
      </AppLayout>
    </ConfigProvider>
  )
}

export default App
